/**
 * Color constants for DataLeadManagement components
 * Provides consistent theming across the data lead management interface
 */

/**
 * Default Mode Colors (Blue theme)
 */
export const DEFAULT_MODE_COLORS = {
  background: '#e3f2fd', // Light blue background
  text: '#1565c0', // Dark blue text
  border: '#bbdefb', // Medium blue border
} as const;

/**
 * Custom Mode Colors (Purple theme)
 */
export const CUSTOM_MODE_COLORS = {
  background: '#f3e5f5', // Light lavender background
  text: '#7b1fa2', // Dark purple text
  border: '#e1bee7', // Medium purple border
} as const;

/**
 * Information/Status Colors (matching Default mode for consistency)
 */
export const INFO_COLORS = {
  background: DEFAULT_MODE_COLORS.background,
  text: DEFAULT_MODE_COLORS.text,
  border: DEFAULT_MODE_COLORS.border,
  shadow: 'rgba(21, 101, 192, 0.1)', // Light blue shadow
} as const;

/**
 * Assignment Mode Colors - combines both themes
 */
export const ASSIGNMENT_MODE_COLORS = {
  default: DEFAULT_MODE_COLORS,
  custom: CUSTOM_MODE_COLORS,
} as const;
